module.exports = __webpack_public_path__ + "static/sports-broadcast-students-prepare-for-prime-time-d7c5fa49ba7c85b40c38125ce542db8a.jpg";